import { DateFormatter } from '@components'

import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { getLocalDateFromDateString } from '../../../../../../../../utils/getLocalDateFromDateString'
import { ImportedInvoiceApproved } from '../../../../../../types/importedInvoiceApproved'
import { ImportedInvoiceDetailRow, ImportedInvoiceDetailRows } from '../ImportedInvoiceDetailRows'

interface ImportedInvoiceGeneralRowsProps {
  approved: ImportedInvoiceApproved
}

export const ImportedInvoiceGeneralRows = ({ approved }: ImportedInvoiceGeneralRowsProps): ReactElement => {
  const { t } = useTranslation()

  const issueDate = useMemo(() => getLocalDateFromDateString(approved.entryDate), [approved.entryDate])

  return (
    <ImportedInvoiceDetailRows>
      <ImportedInvoiceDetailRow label={t('imported_invoices.review.form.reference_number')} value={approved.number} />
      <ImportedInvoiceDetailRow
        label={t('imported_invoices.review.form.issue_date')}
        value={issueDate ? <DateFormatter value={issueDate} /> : '-'}
      />
    </ImportedInvoiceDetailRows>
  )
}
